import React from 'react';
import SubcourseOverallCard from '../../../../components/Learner/LanguageLearning/SubcourseOverallCard';
import QuickPracticeButton from '../../../../components/Learner/LanguageLearning/QuickPracticeButton';
import WritingPracticeButton from '../../../../components/Learner/LanguageLearning/WritingPracticeButton';
import SpeakingPracticeButton from '../../../../components/Learner/LanguageLearning/SpeakingPracticeButton';
import DrillVocabButton from '../../../../components/Learner/LanguageLearning/DrillVocabButton';
import NotesView from '../../../../components/Learner/LanguageLearning/NotesView';
import LessonsTreeTable from '../../../../components/Learner/LanguageLearning/LessonsTreeTable';

export default function LevelPanelDesktopView({
  level,
  levelNumber,
  progress,
  courseTreeLoading,
  isMastered,
  practices,
  vocabReady,
  vocabStats,
  notes,
  notesLoading,
  displayLessons,
  skills,
  skillsCache,
  desktopExpandedLessonIds,
  treeLoadingLessonId,
  selectedSkillId,
  activeLessonId,
  isLessonsLoading,
  shouldCollapseLessonList,
  onQuickPracticeStart,
  onWritingPracticeStart,
  onSpeakingPracticeStart,
  onDrillVocabStart,
  onLessonClick,
  onSkillSelect,
  onToggleLesson,
  onReadingMaterialClick,
}) {
  return (
    <div className="level-panel w-full flex flex-col gap-4 m-0 p-0 box-border">
      <div className="level-panel-first-row flex flex-row gap-4 items-stretch max-[1100px]:gap-2.5 max-md:flex-col">
        <div className="level-panel-top flex-1 min-w-0 grid grid-cols-4 gap-4 m-0 p-3 box-border bg-[#f1f5f9] dark:bg-[#1e293b] rounded-[20px] border border-[#e2e8f0] dark:border-white/10 max-[1100px]:p-2 max-[1100px]:gap-2.5 max-md:grid-cols-2 max-md:gap-3 max-md:flex-none max-md:flex-col">
          <SubcourseOverallCard
            level={level}
            levelNumber={levelNumber}
            progress={progress}
            loading={courseTreeLoading}
            isMastered={isMastered}
          />
          <div className="practice-section flex-1 min-w-0 flex flex-col gap-2 touch-action-pan-y">
            <div className="practice-cards-container flex flex-row gap-4 flex-1 p-0 m-0 box-border w-full min-w-0 items-stretch max-md:flex-col max-md:gap-3">
              <QuickPracticeButton
                level={practices.quick.level}
                completed={practices.quick.progress}
                total={100}
                onStart={onQuickPracticeStart}
              />
              <WritingPracticeButton
                level={practices.writing.level}
                completed={practices.writing.progress}
                total={100}
                onStart={onWritingPracticeStart}
              />
              <SpeakingPracticeButton
                level={practices.speaking.level}
                completed={practices.speaking.progress}
                total={100}
                onStart={onSpeakingPracticeStart}
              />
            </div>
          </div>
        </div>
        {vocabReady && (
          <DrillVocabButton
            level={courseTreeLoading ? null : vocabStats.level ?? 0}
            completed={courseTreeLoading ? null : vocabStats.progress ?? 0}
            total={100}
            onStart={onDrillVocabStart}
            loading={courseTreeLoading}
          />
        )}
      </div>

      <div className="level-panel-bottom w-full flex flex-row gap-4 items-start m-0 p-0 box-border max-md:flex-col max-md:gap-0">
        <div className="lessons-tree-wrapper flex-[0_0_auto] mr-0 max-md:w-full max-md:border-b max-md:border-[var(--border-light)]">
          <LessonsTreeTable
            lessons={displayLessons}
            skillsCache={skillsCache}
            expandedLessonIds={desktopExpandedLessonIds}
            loadingLessonId={treeLoadingLessonId}
            onLessonClick={onLessonClick}
            onSkillSelect={onSkillSelect}
            onToggleLesson={onToggleLesson}
            loading={isLessonsLoading}
            selectedSkillId={selectedSkillId}
            activeLessonId={activeLessonId}
            initialCollapsed={shouldCollapseLessonList}
            onQuickPracticeStart={onQuickPracticeStart}
            onSpeakingPracticeStart={onSpeakingPracticeStart}
            onWritingPracticeStart={onWritingPracticeStart}
            quickStats={practices.quick}
            writingStats={practices.writing}
            speakingStats={practices.speaking}
            loadingStats={courseTreeLoading}
          />
        </div>

        <div className="notes-view-wrapper flex-1 min-w-0 pr-0 flex flex-col gap-3">
          <div style={{ position: 'relative' }}>
            <NotesView
              title="Reading Material"
              notes={notes}
              loading={notesLoading}
              skillId={selectedSkillId}
              lessonId={activeLessonId}
              skills={skills}
              currentSkillId={selectedSkillId}
              onSkillChange={onSkillSelect}
              onReadingMaterialClick={onReadingMaterialClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
